import styled from '@emotion/styled';

export const RecentTimeEntriesFooter = styled.div`
    margin-top: 48px;
    text-align: center;
`;
